import styled, { css } from 'styled-components/macro';
import { IBackground, ISize } from './modal';

const position = css`
  position: absolute;
  z-index: 999;
`;

const sizes: Record<ISize, { [key: string]: any }> = {
  s: css`
    max-width: 450px;
  `,
  m: css`
    max-width: 750px;
  `,
  l: css`
    max-width: 1100px;
  `,
  xl: css`
    max-width: 1500px;
  `,
};

const backgrounds: Record<IBackground, { [key: string]: any }> = {
  white: css`
    background-color: #ffffff;
  `,
  grey: css`
    background-color: #f8f9fa;
  `,
};

export const Fade = styled.div`
  ${position};
  position: fixed;
  background: rgba(1, 9, 23, 0.2);
  backdrop-filter: blur(2px);
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
`;

export const ModalContainer = styled.div<{
  size: ISize;
  background: IBackground;
  stableHeight: boolean;
}>`
  ${position};
  ${(props) => sizes[props.size]}
  ${(props) => backgrounds[props.background]}
  display: flex;
  width: 80vw;
  height: ${(props) =>
    !props.stableHeight
      ? 'fit-content'
      : props.size === 'xl'
      ? '75vh'
      : '60vh'};
  max-height: ${(props) => (props.size === 'xl' ? '75vh' : '60vh')};
  inset: 0;
  margin: auto auto;
  padding: 12px;
  border-radius: 16px;
  box-shadow: 0 8px 8px 0 rgba(7, 43, 114, 0.04),
    0 12px 28px 0 rgba(0, 32, 51, 0.12);
`;

export const CrossContainer = styled.div`
  ${position};
  width: fit-content;
  height: fit-content;
  right: -8px;
  top: -16px;
`;
